import { render, staticRenderFns } from "./ClipboardSavedToast.vue?vue&type=template&id=33973833&scoped=true"
import script from "./ClipboardSavedToast.vue?vue&type=script&lang=js"
export * from "./ClipboardSavedToast.vue?vue&type=script&lang=js"
import style0 from "./ClipboardSavedToast.vue?vue&type=style&index=0&id=33973833&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33973833",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33973833')) {
      api.createRecord('33973833', component.options)
    } else {
      api.reload('33973833', component.options)
    }
    module.hot.accept("./ClipboardSavedToast.vue?vue&type=template&id=33973833&scoped=true", function () {
      api.rerender('33973833', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/clipboard/ClipboardSavedToast.vue"
export default component.exports